import GeneralInformationTab from "./GeneralInformationTab";

export default GeneralInformationTab;